import './createNonce';
import './css-load-checher.css';

window.__startApp__ = async function __startApp__() {
  const { loadApp } = await import('./bootstrap');
  return loadApp();
};
